import { render } from "./AgendaItem.vue?vue&type=template&id=3a43f71a"
import script from "./AgendaItem.vue?vue&type=script&lang=js"
export * from "./AgendaItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__